module.exports = __webpack_public_path__ + "static/media/patient.5ea6c675.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/patient.png
// module id = 13889
// module chunks = 0